"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '7 3 90 90';

var Filter = function Filter() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M91.333,25.354c0,3.325-2.695,6.021-6.021,6.021H14.688c-3.325,0-6.021-2.695-6.021-6.021l0,0 c0-3.325,2.695-6.021,6.021-6.021h70.625C88.638,19.333,91.333,22.029,91.333,25.354L91.333,25.354z"
  }), _react["default"].createElement("path", {
    d: "M81.333,50.657c0,3.325-2.695,6.021-6.021,6.021H24.688c-3.325,0-6.021-2.695-6.021-6.021l0,0 c0-3.325,2.695-6.021,6.021-6.021h50.625C78.638,44.636,81.333,47.332,81.333,50.657L81.333,50.657z"
  }), _react["default"].createElement("path", {
    d: "M66.333,75.959c0,3.325-2.695,6.021-6.021,6.021H39.688c-3.325,0-6.021-2.695-6.021-6.021l0,0 c0-3.325,2.695-6.021,6.021-6.021h20.625C63.638,69.938,66.333,72.634,66.333,75.959L66.333,75.959z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Filter, {
  viewBox: viewBox
});

exports["default"] = _default;